export const SUBMIT_TYPE = {
  GLOBAL: 'GLOBAL',
  LOCAL: 'LOCAL',
  REPORT: 'REPORT',
};
